import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class PdfFormTemplatesAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  getListError() {
    const message = {
      body: 'PDF_FORM_TEMPLATES_GET_LIST_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getOneError() {
    const message = {
      body: 'PDF_FORM_TEMPLATES_GET_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createOneSuccess() {
    const message = {
      body: 'PDF_FORM_TEMPLATES_CREATE_ONE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createOneError() {
    const message = {
      body: 'PDF_FORM_TEMPLATES_CREATE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  uploadOneError() {
    const message = {
      body: 'PDF_FORM_TEMPLATES_UPLOAD_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateOneSuccess() {
    const message = {
      body: 'PDF_FORM_TEMPLATES_UPDATE_ONE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  updateOneError() {
    const message = {
      body: 'PDF_FORM_TEMPLATES_UPDATE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteOneSuccess() {
    const message = {
      body: 'PDF_FORM_TEMPLATES_DELETE_ONE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  deleteOneError() {
    const message = {
      body: 'PDF_FORM_TEMPLATES_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.document-management')
  .service('pdfFormTemplatesAlerts', PdfFormTemplatesAlerts);
